import { combineReducers } from "redux";
import { profileReducer } from "./reducers/profile-reducers";
import { creditCardReducer } from "./reducers/credit-card-reducer";
export default combineReducers({
  profileReducer,
  creditCardReducer
});
